import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-shared-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    providers: [NgbPaginationConfig],
})
export class PaginationComponent implements OnInit {
    page: number = 1;
    @Input() size: number;
    @Input() perPage: number;
    @Output() onChange: EventEmitter<any> = new EventEmitter();

    constructor(config: NgbPaginationConfig) {
        // config.boundaryLinks = true;
        config.ellipses = false;
        config.rotate = true;
        config.maxSize = 5;
    }

    ngOnInit(): void {
        if (!this.size) {
            throw new Error('The size of collection must be specified');
        }
        // //console.log(this.size);
        // //console.log(this.perPage);
    }
}
